import { useEffect, useState } from "react";
import { apiGetActiveCustomFields } from "../../../lib/api/platform";
import { format, parseISO } from "date-fns";

import { apiGetMember } from "../../../lib/api/user";

function SingleSelect({ field, value }) {
  const [temp, setTemp] = useState({
    field: "",
    value: { value: "", name: "" },
  });
  const [title, setTitle] = useState("");

  useEffect(() => {
    async function fetchUser(id) {
      const result = await apiGetMember(id);
      if (result) {
        setTitle(result.title);
      }
    }
    if (value) {
      const index = value.findIndex((e) => e.field === field.id);
      if (index >= 0) {
        // console.log(value);
        setTemp(value[index]);
        if (field.type === "singleSelectAll") {
          fetchUser(value[index].value.value);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  if (temp?.value.name.length > 0) {
    return (
      <div className="mt-2 col-span-7 sm:col-span-3 border border-gray-800 pb-1 text-[12px]">
        <div className="bg-gray-200 border-b border-gray-800 mb-1">
          <p className="text-center font-medium">{field.title}</p>
        </div>
        <div className="flex items-center justify-center py-1 px-4">
          <p className="text-black text-xs 2xl:text-sm">
            {temp.value.name}
            {title?.length > 0 && `, ${title}`}
          </p>
        </div>
      </div>
    );
  } else {
    return null;
  }
}

function OrderedList({ field, value }) {
  const [temp, setTemp] = useState({
    field: "",
    value: { value: "", name: "" },
  });

  useEffect(() => {
    if (value) {
      const index = value.findIndex((e) => e.field === field.id);
      if (index >= 0) {
        setTemp(value[index]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  if (temp?.value.name.length > 0) {
    return (
      <div className="mt-2 col-span-7 md:col-span-3 border border-gray-800 pb-1 text-[12px]">
        <div className="bg-gray-200 border-b border-gray-800 mb-1">
          <p className="text-center font-medium">{field.title}</p>
        </div>
        <div className="flex items-center justify-center py-1 px-4">
          <p className="text-black text-xs 2xl:text-sm">{temp.value.name}</p>
        </div>
      </div>
    );
  } else {
    return null;
  }
}

function MultiSelect({ field, value }) {
  const [temp, setTemp] = useState({
    field: "",
    value: [],
  });

  useEffect(() => {
    if (value) {
      const index = value.findIndex((e) => e.field === field.id);
      if (index >= 0) {
        setTemp(value[index]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  if (temp?.value.length > 0) {
    return (
      <div className="mt-2 col-span-7 md:col-span-3 border border-gray-800 pb-1 text-[12px]">
        <div className="bg-gray-200 border-b border-gray-800 mb-1">
          <p className="text-center font-medium">{field.title}</p>
        </div>
        <div className="flex items-center space-x-1.5 px-2">
          {temp.value.map((x, index) => (
            <div key={x.value} className="inline-flex items-center py-1">
              <p className="text-black text-xs 2xl:text-sm">{x.name},</p>
            </div>
          ))}
        </div>
      </div>
    );
  } else {
    return null;
  }
}

function UserList({ field, value }) {
  const [temp, setTemp] = useState({
    field: "",
    value: { value: "", name: "" },
  });

  useEffect(() => {
    if (value) {
      const index = value.findIndex((e) => e.field === field.id);
      if (index >= 0) {
        setTemp(value[index]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  if (temp?.value.name.length > 0) {
    return (
      <div className="col-span-4 sm:col-span-2">
        <p className="block text-sm font-medium text-zinc-500">{field.title}</p>
        <div className="mt-1 block w-full text-coolGray-200 rounded-md py-2 px-3 sm:text-sm xl:text-base">
          <p>{temp.value.name}</p>
        </div>
      </div>
    );
  } else {
    return null;
  }
}

function Text({ field, value }) {
  const [temp, setTemp] = useState("");

  useEffect(() => {
    if (value) {
      const index = value.findIndex((e) => e.field === field.id);
      if (index >= 0) {
        setTemp(value[index].value);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  if (temp?.length > 0) {
    return (
      <div className="mt-2 col-span-7 md:col-span-3 border border-gray-800 pb-1 text-[12px]">
        <div className="bg-gray-200 border-b border-gray-800 mb-1">
          <p className="text-center font-medium">{field.title}</p>
        </div>
        <div className="">
          <p className="text-center">{temp}</p>
        </div>
      </div>
    );
  } else {
    return null;
  }
}

function TextArea({ field, value }) {
  const [temp, setTemp] = useState("");

  useEffect(() => {
    if (value) {
      const index = value.findIndex((e) => e.field === field.id);
      if (index >= 0) {
        setTemp(value[index].value);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  if (temp?.length > 0) {
    return (
      <div className="mt-2 col-span-7 md:col-span-3 border border-gray-800 pb-1 text-[12px]">
        <div className="bg-gray-200 border-b border-gray-800 mb-1">
          <p className="text-center font-medium">{field.title}</p>
        </div>
        <div className="">
          <p className="text-center whitespace-pre-line">{temp}</p>
        </div>
      </div>
    );
  } else {
    return null;
  }
}

function Date({ field, value }) {
  const [temp, setTemp] = useState("");

  useEffect(() => {
    if (value) {
      const index = value.findIndex((e) => e.field === field.id);
      if (index >= 0) {
        const date = format(parseISO(value[index].value), "MMM dd, yyyy");
        setTemp(date);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  if (temp?.length > 0) {
    return (
      <div className="mt-2 col-span-7 md:col-span-3 border border-gray-800 pb-1 text-[12px]">
        <div className="bg-gray-200 border-b border-gray-800 mb-1">
          <p className="text-center font-medium">{field.title}</p>
        </div>
        <div className="">
          <p className="text-center">{temp}</p>
        </div>
      </div>
    );
  } else {
    return null;
  }
}

function CustomFieldPrint({ client, fields }) {
  const [customFields, setCustomFields] = useState();
  const [values, setValues] = useState();

  useEffect(() => {
    async function fetchFields() {
      const fieldResult = await apiGetActiveCustomFields(client);
      if (fieldResult) {
        let newFields = [];
        for (const x of fieldResult) {
          if (x.public) {
            const type = JSON.parse(x.fieldType);
            let tempData = {
              id: x.id,
              title: x.title,
              description: x.description,
              type: type.value,
              fieldOptions: x.fieldOptions,
            };
            newFields.push(tempData);
          }
        }
        setCustomFields(newFields);
      }
    }
    if (client) {
      fetchFields();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client]);

  useEffect(() => {
    if (fields) {
      let tempFields;
      try {
        tempFields = JSON.parse(fields);
        if (tempFields) {
          setValues(tempFields);
        }
      } catch (error) {
        // console.log("inside customFields parse error throw");
        // do nothing
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fields]);

  return (
    <>
      {customFields?.map((field, index) => {
        switch (field.type) {
          case "singleSelect":
          case "singleSelectAll":
            return (
              <SingleSelect key={index * 56} field={field} value={values} />
            );
          case "orderList":
            return (
              <OrderedList key={index * 56} field={field} value={values} />
            );

          case "multiSelect":
          case "multiSelectAll":
            return (
              <MultiSelect key={index * 56} field={field} value={values} />
            );

          case "userList":
            return <UserList key={index * 56} field={field} value={values} />;

          case "date":
            return <Date key={index * 56} field={field} value={values} />;
          case "textArea":
            return <TextArea key={index * 56} field={field} value={values} />;

          default:
            return <Text key={index * 56} field={field} value={values} />;
        }
      })}
    </>
  );
}

export default CustomFieldPrint;
